import React from 'react';
import './LoadingIcon.scss';

const LoadingIcon: React.FC = () => <div className='loading-icon' />;

export default LoadingIcon;
